import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { StatsComponent } from './stats/stats.component';
import { CardsComponent } from './cards/cards.component';
import { SettlementsComponent } from './settlements/settlements.component';
import { MaterialModule } from '../../material/material.module';
import { SharedElementsModule } from '../shared/sharedElements.module';
import { RouterModule } from '@angular/router';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LastTransactionsComponent } from './stats/last-transactions/last-transactions/last-transactions.component';
import { FleetUsageComponent } from './stats/fleet-usage/fleet-usage.component';
import { InvoicesComponent } from './settlements/invoices/invoices.component';
import { AgreementComponent } from './settlements/agreement/agreement.component';
import { PipesModule } from '../../pipes/pipes.module';
import { CardComponent } from './forms/card/card.component';
import { CardsSummaryComponent } from './cards/cards-summary/cards-summary.component';
import { LimitsSummaryComponent } from './cards/limits-summary/limits-summary.component';
import { LimitComponent } from './forms/limit/limit.component';
import { FleetUsageLevelComponent } from './stats/fleet-usage-level/fleet-usage-level.component';
import { SalesComponent } from './stats/sales/sales.component';
import { FleetQuantitativeUsageComponent } from './stats/fleet-quantitative-usage/fleet-quantitative-usage.component';
import { MomentModule } from 'angular2-moment';
import { CardDetailsComponent } from './card-details/card-details.component';
import 'moment/locale/pl';

@NgModule({
  imports:      [ CommonModule,
                  FormsModule,
                  ChartsModule,
                  SharedElementsModule,
                  RouterModule,
                  ReactiveFormsModule,
                  FormsModule,
                  MaterialModule,
                  MomentModule,
                  PipesModule ],
  declarations: [ DashboardComponent,
                  StatsComponent,
                  CardsComponent,
                  SettlementsComponent,
                  SalesComponent,
                  LastTransactionsComponent,
                  FleetUsageComponent,
                  InvoicesComponent,
                  AgreementComponent,
                  CardComponent,
                  LimitComponent,
                  CardsSummaryComponent,
                  LimitsSummaryComponent,
                  FleetUsageLevelComponent,
                  FleetQuantitativeUsageComponent,
                  CardDetailsComponent ]
})
export class DashboardModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/dashboard.module.ts